// General
import "./request-verified-photo-dialog.scss";
import { useEffect } from "react";
// Services
import { useRequestVp3Mutation } from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateVp3ExchangeStatus } from "../../../../redux/store/userCardStore";
import {
  updateInfoToast,
  updateErrorToast,
} from "../../../../redux/store/toastStore";
import { updateRequestVerifiedPhotoDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog } from "@mui/material";
// i18next
import { useTranslation, Trans } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";
// Components
import Spinner from "../../elements/spinner/spinner";

const RequestVerifiedPhotoDialog = () => {
  // API variables
  const [
    requestVp3,
    {
      data: requestVp3Data,
      error: requestVp3ErrorData,
      isLoading: requestVp3Loading,
      isSuccess: requestVp3Success,
      isError: requestVp3Error,
    },
  ] = useRequestVp3Mutation();

  // Redux variables
  const requestVerifiedPhotoDialog = useSelector(
    (state) => state.dialog.requestVerifiedPhotoDialog
  );
  const id = useSelector((state) => state.userCard.id);
  const isSugarbaby = useSelector((state) => state.userCard.isSugarbaby);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!requestVerifiedPhotoDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-RequestPrivatePhoto-Dialog",
      },
    });
  }, [requestVerifiedPhotoDialog]);

  // Lifecycle | Check for update | Request VP3 API Response
  useEffect(() => {
    if (requestVp3Loading) {
    } else if (requestVp3Success) {
      switch (requestVp3Data?.status) {
        case 1:
          dispatch(
            updateVp3ExchangeStatus(requestVp3Data?.data?.request?.status)
          );
          onCloseDialog();
          break;
        default:
          const obj = {
            message: requestVp3Data?.message,
            autoClose: 4000,
          };
          dispatch(updateInfoToast(obj));
          break;
      }
    } else if (requestVp3Error) {
      if (requestVp3ErrorData?.status === 401) {
        onNavigate(routeConst.logout.path);
      } else {
        const obj = {
          message: requestVp3ErrorData?.data?.message,
          autoClose: 4000,
        };
        dispatch(updateErrorToast(obj));
      }
    }
  }, [requestVp3Loading, requestVp3Success, requestVp3Error]);

  // Event Handlers | Button
  const onRequestPrivatePhoto = () => {
    const obj = {
      user_id: id,
    };
    requestVp3(obj);
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateRequestVerifiedPhotoDialog(false));
  };

  return (
    <Dialog
      className="custom-radius25-dialog"
      open={requestVerifiedPhotoDialog}
      onClose={onCloseDialog}
    >
      <div id="request-verified-photo-dialog">
        <div className="padding-container">
          <div className="title">
            {t("profile.request_verified_photos_to_view_title")}
          </div>

          <div className="description">
            <Trans
              i18nKey={"profile.verified_photo_desc"}
              components={{ br: <br /> }}
            />
          </div>

          <div className="button-container">
            <div className="request-button" onClick={onRequestPrivatePhoto}>
              {requestVp3Loading ? (
                <Spinner size={19} isPadding={false} color="white-spinner" />
              ) : (
                t("profile.request_now")
              )}
            </div>

            <div className="cancel-button" onClick={onCloseDialog}>
              {t("common.cancel")}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default RequestVerifiedPhotoDialog;
